import axios from 'axios';
import { store } from '../redux/store';
import { logout } from 'components/../redux/actions/auth';

const withAuth = (headers = {}) => {
    const accessToken = localStorage.getItem('userToken');
    return {
        ...headers,
        Authorization: `Token ${accessToken}`
    };
};

const base = (method, url, props = {}, secure = true) => {
    const { data = {}, headers = {}, params = {}, cancelToken, ...rest } = props;
    if (secure) {
        let tmp = {
            method,
            url,
            data,
            params,
            headers: withAuth(headers),
            ...rest
        };
        if (cancelToken) {
            tmp.cancelToken = cancelToken;
        }
        return axios(tmp).catch((err) => {
            if (err.response.status === 401) {
                store.dispatch(logout());
            }
            throw err;
        });
    } else {
        return axios({
            method,
            url,
            headers,
            data,
            params
        });
    }
};

const DownloadFileApiHelper = {};

['get', 'post', 'put', 'patch', 'delete'].forEach((method) => {
    DownloadFileApiHelper[method] = base.bind(null, method);
});

export default DownloadFileApiHelper;
